function setKey(keyName, keyData) {
  localStorage.setItem(keyName, JSON.stringify(keyData))
  return
}

function getKey(keyName) {
  const keyData = localStorage.getItem(keyName)
  return JSON.parse(keyData)
}

function removeKey(keyName) {
  const keyData = localStorage.removeItem(keyName)
  return
}

export default {
  setKey,
  getKey,
  removeKey,
}
